"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { env } from "~/setup/env";
import { useLanguage } from "~/translations/loader/use-language";
export default function CompanyEonSverige() {
  const $ = _c(6);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobad/diversity-bg.png)`,
      backgroundSize: "cover"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.sverige_company_text) {
    t1 = <div className="my-auto p-8"><div className="text-lg" data-source="lc">{t.sverige_company_text}</div></div>;
    $[1] = t.sverige_company_text;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CustomImage alt="E.ON Sverige" className="h-full self-center object-cover" height={720} src="images/jobad/sverige/company_sverige.webp" width={1280} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <section className="outer-container bg-[#0f738A] bg-fixed py-container text-primary" id="company" style={t0}><div className="inner-container bg-white"><div className="grid gap-8 lg:auto-cols-fr lg:grid-flow-col xl:gap-12">{t1}{t2}</div></div></section>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}